/*
 * @Author: your name
 * @Date: 2020-11-03 15:29:47
 * @LastEditTime: 2021-08-05 10:16:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\router\index.js
 */

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',     //首页
      name: 'index',
      meta:{index:'/'},
      component: resolve  => require(['./../pages/index'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve  => require(['./../pages/login'], resolve)
    },
    {
      path: '/admin',
      name: 'admin',
      component: resolve  => require(['./../pages/admin'], resolve)
    },
    {
      path: '/vedioPlay',    //课程学习视频播放
      name: 'vedioPlay',
      meta:{
        index:'/trainPosition',
        // requireAuth: true,
      },
      component: resolve  => require(['./../components/train/vedioPlay'], resolve)
    },
    {
      path: '/coursevideo',    //课程学习视频播放
      name: 'coursevideo',
      meta:{
        index:'/trainPosition',
        // requireAuth: true,
      },
      component: resolve  => require(['./../components/train/coursevideo'], resolve)
    },
    
    {
      path: '/home',
      // name: 'home',
      component: resolve => require(['./../pages/home'], resolve),
      children: [
        
        {
          path: '/news',      //新闻资讯
          name: 'news',
          meta:{index:'/news'},
          component: resolve  => require(['./../pages/news'], resolve)
        },
        {
          path: '/noticeDetail',      //新闻详情
          name: 'noticeDetail',
          meta:{index:'/news'},
          component: resolve  => require(['./../components/news/noticeDetail'], resolve)
        },
        {
          path: '/throughCompany',   //直通企业
          name: 'throughCompany',
          meta:{index:'/throughCompany'},
          component: resolve  => require(['./../pages/throughCompany'], resolve)
        },
        {
          path: '/enterpriseDetail',   //直通企业详情
          name: 'enterpriseDetail',
          meta:{index:'/throughCompany'},
          component: resolve  => require(['./../components/enterprise/enterpriseDetail'], resolve)
        },
        {
          path: '/trainingBase',      //基地培训
          name: 'trainingBase',
          meta:{index:'/trainingBase'},
          component: resolve  => require(['./../pages/trainingBase'], resolve)
        },
        {
          path: '/baseDetail',      //基地详情
          name: 'baseDetail',
          meta:{index:'/trainingBase'},
          component: resolve  => require(['./../components/train/baseDetail'], resolve)
        },
        {
          path: '/onLineTrain',      //线上实训详情
          name: 'onLineTrain',
          meta:{
            index:'/trainingBase',
            // requireAuth: true
          },
          component: resolve  => require(['./../components/train/onLineTrain'], resolve)
        },
        {
          path: '/trainPosition',    //培训岗位
          name: 'trainPosition',
          meta:{index:'/trainPosition'},
          component: resolve  => require(['./../pages/trainPosition'], resolve)
        },
        {
          path: '/trainDetail',    //培训岗位详情
          name: 'trainDetail',
          meta:{index:'/trainPosition'},
          component: resolve  => require(['./../components/train/trainDetail'], resolve)
        },
        {
          path: '/certDetails',    //学习认证详情
          name: 'certDetails',
          meta:{index:'/trainPosition'},
          component: resolve  => require(['./../components/train/certDetails'], resolve)
        },
        {
          path: '/trainCourse',    //培训岗位课程表
          name: 'trainCourse',
          meta:{index:'/trainPosition'},
          component: resolve  => require(['./../components/train/trainCourse'], resolve)
        },
        {
          path: '/learning',    //学习
          name: 'learning',
          meta:{index:'/learning'},
          component: resolve  => require(['./../pages/learning'], resolve)
        },
        {
          path: '/courseDetail',    //学习课程详情
          name: 'courseDetail',
          meta:{
            index:'/learning',
          },
          component: resolve  => require(['./../components/train/courseDetail'], resolve)
        },
        {
          path: '/coursePay',    //学习课程支付
          name: 'coursePay',
          meta:{
            index:'/learning',
            // requireAuth: true,
          },
          component: resolve  => require(['./../components/train/coursePay'], resolve)
        },
        {
          path: '/coursePayConfirm',    //学习课程支付确认
          name: 'coursePayConfirm',
          meta:{
            index:'/learning',
            // requireAuth: true,
          },
          component: resolve  => require(['./../components/train/coursePayConfirm'], resolve)
        },
        {
          path: '/postDetail',    //岗位详情+1
          name: 'postDetail',
          meta:{index:'/trainingBase'},
          component: resolve  => require(['./../components/train/postDetail'], resolve)
        },
        {
          path: '/channelEnquiry',    //合作渠道+1
          name: 'channelEnquiry',
          // meta:{index:'/trainPosition'},
          component: resolve  => require(['./../components/CertEnquiry/channelEnquiry'], resolve)
        },
        // {
        //   path: '/courseDetail',    //培训岗位课程学习 
        //   name: 'courseDetail',
        //   meta:{
        //     index:'/trainPosition',
        //     // requireAuth: true,
        //   },
        //   component: resolve  => require(['./../components/train/courseDetail'], resolve)
        // },
      
        {
          path: '/normalQustion',   //常见问题
          name: 'normalQustion',
          meta:{index:'/normalQustion'},
          component: resolve  => require(['./../pages/normalQustion'], resolve)
        },
        {
          path: '/aboutUs',   //关于我们
          name: 'aboutUs',
          meta:{index:'/aboutUs'},
          component: resolve  => require(['./../pages/aboutUs'], resolve)
        },
        {
          path: '/contactUs',    //联系我们
          name: 'contactUs',
          component: resolve  => require(['./../pages/contactUs'], resolve)
        },
        {
          path: '/sectionTest',    //联系我们
          name: 'sectionTest',
          component: resolve  => require(['./../components/train/sectionTest'], resolve)
        },
        {
          path: '/expertTeam',   //专家团队
          name: 'expertTeam',
          meta:{index:'/expertTeam'},
          component: resolve  => require(['./../pages/expertTeam'], resolve)
        },
        {
          path: '/professDetail',   //专家详情
          name: 'professDetail',
          meta:{index:'/expertTeam'},
          component: resolve  => require(['./../pages/professDetail'], resolve)
        },
        {
          path: '/equCheckout',   //设备检验
          name: 'equCheckout',
          component: resolve  => require(['./../components/equCheckout/detection'], resolve)
        },
       
      ]
    },
    {
      path: '/exam',
      component: resolve => require(['./../pages/exam'], resolve),
      children: [
        {
          path: '/',   //默认
          redirect: '/checkInformation'
        },
        {
          path: '/checkInformation',    //考试 信息核对
          name: 'checkInformation',
          meta:{
            requireAuth: true,
            showFooter:true
          },
          component: resolve  => require(['./../components/exam/checkInformation'], resolve)
        },
        {
          path: '/examExplain',    //考试需知
          name: 'examExplain',
          meta:{
            requireAuth: true,
            showFooter:true
          },
          component: resolve  => require(['./../components/exam/examExplain'], resolve)
        },
        {
          path: '/veriFace',    //考试-人脸识别
          name: 'veriFace',
          meta:{
            requireAuth: true,
            showFooter:true
          },
          component: resolve  => require(['./../components/exam/veriFace'], resolve)
        },
        {
          path: '/examAnswer',    //考试-答题
          name: 'examAnswer',
          meta:{
            requireAuth: true,
            showFooter:true
          },
          component: resolve  => require(['./../components/exam/examAnswer'], resolve)
        },
        {
          path: '/examMock',    //考试-模拟 
          name: 'examMock',
          meta:{
            showFooter:true
          },
          component: resolve  => require(['./../components/exam/examMock'], resolve)
        },
        {
          path: '/myCenter',   //个人中心
          name: 'myCenter',
          meta:{
            requireAuth: true,
          },
          component: resolve  => require(['./../pages/myCenter'], resolve)
        },
      ]
    },
    {
      path: '/inquire',
      component: resolve => require(['./../pages/inquire'], resolve),
      children: [
        {
          path: '/',
          redirect: '/certEnquiry'
        },
        {
          path: '/certEnquiry',   //证书查询
          name: 'certEnquiry',
          meta:{index:'/certEnquiry'},
          component: resolve  => require(['./../pages/certEnquiry'], resolve)
        },
        {
          path: '/certEnquiryResult',   //证书查询
          name: 'certEnquiryResult',
          meta:{index:'/certEnquiry'},
          component: resolve  => require(['./../components/certEnquiry/certEnquiryResult'], resolve)
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { //如果未匹配到路由
    from.name ? next({ name:from.name }) : next('/');  //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    }else{
      var tokenStr = window.sessionStorage.getItem('token')
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (tokenStr)  next();  // 获取当前的token是否存在
    else  next({name:'login'})
  }
  else next(); // 如果不需要权限校验，直接进入路由界面
  window.scrollTo(0,0);    //默认滚动条在顶部
    }
  
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js